// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__DLF4f"};